import { isValidPhoneNumber } from 'libphonenumber-js';

export default (values, props) => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = 'Required';
  } else if (values.firstName.length < 2) {
    errors.firstName = 'Must be 2 characters or more';
  }

  if (!values.lastName) {
    errors.lastName = 'Required';
  } else if (values.lastName.length < 2) {
    errors.lastName = 'Must be 2 characters or more';
  }

  if (values.phoneNumber && values.phoneNumber !== props.initialValues?.phoneNumber && !isValidPhoneNumber(`+${values.phoneNumber}`)) {
    errors.phoneNumber = 'Invalid phone number';
  }

  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,62}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.projectId) {
    errors.projectId = 'Required';
  }

  return errors;
};
